"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.syncAccountStatus = exports.supportedProviders = exports.standardProviderSuffix = exports.splitViewTypes = exports.retrofitErrorCode = exports.recoveryMethods = exports.priceAlertStatus = exports.premiumSources = exports.premiumErrorCode = exports.oauthErrors = exports.nudgeTypes = exports.nudgeStatus = exports.inboxZeroBackgroundTypes = exports.inboxBreakErrorCode = exports.imapErrorCode = exports.imapConnectionTypes = exports.historyTypes = exports.filterTypes = exports.connectionTypes = exports.connectionSyncStatus = exports.connectionStatus = exports.connectionDeleteOption = exports.commonErrorCode = exports.cleanupTypes = exports.cleanupStatus = exports.betaFeatures = exports.betaFeatureIds = exports.WM_API_HOST = exports.UPLOAD_SERVER = exports.TIMESTAMP_KEYS = exports.STRIPE_API_KEY = exports.RECAPTCHA_GOOGLE_CLIENT_ID_V2 = exports.RECAPTCHA_GOOGLE_CLIENT_ID = exports.RECAPTCHA_GOOGLE_API = exports.OAUTH_GOOGLE_SCOPES = exports.OAUTH_GOOGLE_CLIENT_ID = exports.NOAUTH_PREFIX = exports.MINIMUM_UNDO_DURATION = exports.INVALID_RESPONSE = exports.GOOGLE_API = exports.FILE_LOAD_ERROR_MESSAGE = exports.EXTRA_TOKEN_HEADER = exports.DEFAULT_SETTING_VALUES = exports.CONTENT_DISPOSITION_INLINE = exports.CONTENT_DISPOSITION_ATTACHMENT = exports.CASTLE_TOKEN_HEADER = exports.CASTLE_APP_ID = exports.AUTH_PASSWORD_HEADER = exports.API_V1 = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _get = _interopRequireDefault(require("lodash/get"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var config = window.onmailConfig;
var API_V1 = exports.API_V1 = 'v1';
var NOAUTH_PREFIX = exports.NOAUTH_PREFIX = 'na';
var INVALID_RESPONSE = exports.INVALID_RESPONSE = 'Invalid Response';
var FILE_LOAD_ERROR_MESSAGE = exports.FILE_LOAD_ERROR_MESSAGE = 'Error occurred in loading file';

// OAuth Config
// Google
var OAUTH_GOOGLE_CLIENT_ID = exports.OAUTH_GOOGLE_CLIENT_ID = '788312089623-mka2qep229en2j5p7vt9buljs1qekcpq.apps.googleusercontent.com';
var OAUTH_GOOGLE_SCOPES = exports.OAUTH_GOOGLE_SCOPES = 'https://mail.google.com/';
var GOOGLE_API = exports.GOOGLE_API = 'https://apis.google.com/js/api.js';

// Google reCAPTCHA
var RECAPTCHA_GOOGLE_CLIENT_ID = exports.RECAPTCHA_GOOGLE_CLIENT_ID = (0, _get["default"])(config, 'recaptchaKey', '');
var RECAPTCHA_GOOGLE_CLIENT_ID_V2 = exports.RECAPTCHA_GOOGLE_CLIENT_ID_V2 = (0, _get["default"])(config, 'recaptchaKeyV2', '');

// Use reCAPTCHA globally
//
// Reference: https://developers.google.com/recaptcha/docs/faq#can-i-use-recaptcha-globally
var RECAPTCHA_GOOGLE_API = exports.RECAPTCHA_GOOGLE_API = "https://www.recaptcha.net/recaptcha/api.js?render=".concat(RECAPTCHA_GOOGLE_CLIENT_ID);

// Stripe
var STRIPE_API_KEY = exports.STRIPE_API_KEY = (0, _get["default"])(config, 'stripeKey');

// Castle
var CASTLE_APP_ID = exports.CASTLE_APP_ID = (0, _get["default"])(config, 'castleKey');
var CASTLE_TOKEN_HEADER = exports.CASTLE_TOKEN_HEADER = 'x-Castle-Token';

// wmapi
var WM_API_HOST = exports.WM_API_HOST = "https://".concat((0, _get["default"])(config, 'webApiDomain', ''));
var TIMESTAMP_KEYS = exports.TIMESTAMP_KEYS = ['start', 'end'];
var CONTENT_DISPOSITION_INLINE = exports.CONTENT_DISPOSITION_INLINE = 'inline';
var CONTENT_DISPOSITION_ATTACHMENT = exports.CONTENT_DISPOSITION_ATTACHMENT = 'attachment';
var historyTypes = exports.historyTypes = {
  LABELS_ADDED: 'labelsAdded',
  LABELS_REMOVED: 'labelsRemoved',
  MESSAGES_ADDED: 'messagesAdded',
  MESSAGES_DELETED: 'messagesDeleted'
};
var UPLOAD_SERVER = exports.UPLOAD_SERVER = "https://".concat((0, _get["default"])(config, 'uploadServer', ''));
var nudgeTypes = exports.nudgeTypes = {
  NONE: 0,
  REPLY: 1,
  FOLLOWUP: 2
};
var nudgeStatus = exports.nudgeStatus = {
  WAITING: 10001,
  SHOWED: 10002,
  WENT_ON: 10003,
  DISMISSED: 10004,
  EXPIRED: 10005
};
var priceAlertStatus = exports.priceAlertStatus = {
  NO_DROP: -1,
  NOT_CLAIM: 0,
  CLAIM_SUBMITTED: 1,
  TRACKING: 2,
  NEED_VERIFY: 6,
  EXPIRED: -999
};
var cleanupStatus = exports.cleanupStatus = {
  NONE: 0,
  PENDING: 1,
  IGNORED: 2,
  EXECUTED: 3,
  RUNNING: 3
};
var cleanupTypes = exports.cleanupTypes = {
  CALENDAR: 10001,
  ZOOM: 10002,
  WEBEX: 10003,
  THIRD_ACCOUNT: 20001
};
var MINIMUM_UNDO_DURATION = exports.MINIMUM_UNDO_DURATION = 5000;
var DEFAULT_SETTING_VALUES = exports.DEFAULT_SETTING_VALUES = {
  // Display
  'general.display.enableSmartReply': true,
  'general.display.enableFollowUpNudge': true,
  'general.display.enableReplyToNudge': true,
  'general.display.enableMessagePreviewText': true,
  'general.display.enableAttachmentPreview': true,
  'general.display.enablePriceAlert': true,
  'general.display.enableSift': true
};

/**
 * Enums for third-party email connections.
 */

var connectionTypes = exports.connectionTypes = Object.freeze({
  DEFAULT: 0,
  GMAIL_OAUTH: 1,
  YAHOO_OAUTH: 2,
  OUTLOOK_OAUTH: 3,
  OFFICE365_OAUTH: 4,
  EXCHANGE: 5,
  GMAIL_IMAP: 6,
  ICLOUD_IMAP: 7,
  YAHOO_IMAP: 8,
  AOL_IMAP: 9
});
var standardProviderSuffix = exports.standardProviderSuffix = Object.freeze((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, connectionTypes.GMAIL_IMAP.toString(), '@gmail.com'), connectionTypes.ICLOUD_IMAP.toString(), '@icloud.com'), connectionTypes.YAHOO_IMAP.toString(), '@yahoo.com'), connectionTypes.AOL_IMAP.toString(), '@aol.com'));
var imapConnectionTypes = exports.imapConnectionTypes = [connectionTypes.DEFAULT, connectionTypes.GMAIL_IMAP, connectionTypes.ICLOUD_IMAP, connectionTypes.YAHOO_IMAP, connectionTypes.AOL_IMAP];
var supportedProviders = exports.supportedProviders = Object.freeze([connectionTypes.GMAIL_IMAP, connectionTypes.GMAIL_OAUTH, connectionTypes.OUTLOOK_OAUTH, connectionTypes.ICLOUD_IMAP, connectionTypes.YAHOO_IMAP, connectionTypes.AOL_IMAP, connectionTypes.DEFAULT]);
var connectionDeleteOption = exports.connectionDeleteOption = Object.freeze({
  HARD_DELETE: 0,
  SOFT_DELETE: 1
});
var connectionStatus = exports.connectionStatus = Object.freeze({
  ACTIVE: 0,
  INACTIVE: 1,
  PENDING: 2,
  SOFT_DELETE: 3
});
var oauthErrors = exports.oauthErrors = Object.freeze({
  AUTH_ERROR: 1,
  TIMEOUT: 2
});
var connectionSyncStatus = exports.connectionSyncStatus = Object.freeze({
  INCOMPLETE: 0,
  COMPLETE: 1
});
var syncAccountStatus = exports.syncAccountStatus = Object.freeze({
  INITIALIZING: 0,
  SYNCING: 1,
  INVALID: 2,
  ERROR: 3,
  INVALID_CONFIGURATION: 4,
  INVALID_CREDENTIAL: 5,
  THROTTLED: 6,
  TOO_MANY_CONNECTIONS: 7,
  SERVER_ERROR: 8,
  IMAP_ACCESS_NOT_GRANTED: 9
});
var imapErrorCode = exports.imapErrorCode = {
  INVALID_IMAP_SETTINGS: 220008,
  INVALID_SMTP_SETTINGS: 220009,
  EXCEED_LIMIT: 220012
};
var retrofitErrorCode = exports.retrofitErrorCode = _objectSpread(_objectSpread({}, imapErrorCode), {}, {
  INVALID_PASSWORD: 220010,
  MAX_CONNECTIONS: 210013,
  OAUTH_ACCESS_DENIED: 220013
});
var premiumErrorCode = exports.premiumErrorCode = {
  FEATURE_NOT_ENABLE: 260001
};
var inboxBreakErrorCode = exports.inboxBreakErrorCode = {
  SCHEDULED_BREAK_DUPLICATE: 280007
};
var commonErrorCode = exports.commonErrorCode = _objectSpread(_objectSpread(_objectSpread({}, premiumErrorCode), retrofitErrorCode), inboxBreakErrorCode);
var AUTH_PASSWORD_HEADER = exports.AUTH_PASSWORD_HEADER = 'X-Auth-Password';
var EXTRA_TOKEN_HEADER = exports.EXTRA_TOKEN_HEADER = 'X-Extra-Token';
var premiumSources = exports.premiumSources = Object.freeze({
  NONE: '',
  STRIPE: 'stripe',
  APPLE: 'apple',
  GOOGLE: 'google'
});
var betaFeatureIds = exports.betaFeatureIds = {
  retrofit: 1,
  spellCheck: 2,
  multipleAccounts: 3,
  mfa: 4,
  inboxBreak: 5,
  mfaTotp: 6,
  calendar: 7,
  retrofitGmailOAuth: 8
};
var betaFeatures = exports.betaFeatures = {
  retrofit: 'retrofit',
  spellCheck: 'spellCheck',
  multipleAccounts: 'multipleAccounts',
  mfa: 'mfa',
  inboxBreak: 'inboxBreak',
  mfaTotp: 'mfaTotp',
  calendar: 'calenadr',
  retrofitGmailOAuth: 'retrofitGmailOAuth'
};
var splitViewTypes = exports.splitViewTypes = {
  LIST: 'list',
  PREVIEW: 'preview'
};
var filterTypes = exports.filterTypes = {
  SYSTEM: 0,
  CUSTOM: 1,
  SPLIT_INBOX: 2,
  CATEGORY: 3,
  CLEANUP: 4
};
var inboxZeroBackgroundTypes = exports.inboxZeroBackgroundTypes = {
  AUTO: 'auto',
  CUSTOM: 'custom',
  NONE: 'none'
};
var recoveryMethods = exports.recoveryMethods = {
  sms: 'sms',
  email: 'email'
};
//# sourceMappingURL=constants.js.map